module.exports = __webpack_public_path__ + "media/native-apps/naturkartan-f98e55e5.webp";